export enum SupportRequestState {
  Closed = 'closed',
  Open = 'open',
}
